import { Link } from 'react-router-dom';
import { useResourceDefinition } from 'react-admin';
import { Box, Button, Chip, Paper, Typography, alpha } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/EditOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Code } from '../../../../helperComponents/showPrimitives';
import { formatCreatedDate } from '../../../../../helpers/adsJobsHelpers';

export const JobShowHeader = ({ record }) => {
  const { hasEdit } = useResourceDefinition();
  const allRunsFilter = encodeURIComponent(JSON.stringify({ job_name: record.name }));

  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, p: 3, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Typography variant="h4" fontWeight={700}>{record.name}</Typography>
          <Chip size="small" label={record.type} sx={{ bgcolor: 'grey.100' }} />
          {record.enabled ? (
            <Chip
              size="small"
              icon={<CheckIcon />}
              label="enabled"
              color="success"
              variant="outlined"
              sx={{ bgcolor: (theme) => alpha(theme.palette.success.main, 0.12), borderColor: 'transparent' }}
            />
          ) : (
            <Chip size="small" label="disabled" sx={{ bgcolor: 'grey.100' }} />
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<FormatListBulletedIcon />}
            component={Link}
            to={`/ads_ingest_runs?filter=${allRunsFilter}`}
            sx={{ borderColor: 'divider', textTransform: 'none' }}
          >
            All runs
          </Button>
          {hasEdit && (
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<EditIcon />}
              component={Link}
              to={`/ads_jobs/${record.id}`}
              sx={{ borderColor: 'divider', textTransform: 'none' }}
            >
              Edit
            </Button>
          )}
        </Box>
      </Box>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        Job {record.id} · {record.type === 'legacy_csv' && <>report <Code>{record.report}</Code> → </>}
        table <Code>{record.target}</Code> · created by {record.created_by || '–'}, {formatCreatedDate(record.created_at)}
      </Typography>
    </Paper>
  );
};
